var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5991",
    "data-name": "Rectangle 5991",
    width: 20,
    height: 20,
    transform: "translate(0.47)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_680",
    "data-name": "Mask Group 680",
    transform: "translate(-0.47)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_679",
    "data-name": "Mask Group 679",
    transform: "translate(2.254 4.174)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "message"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55841",
    "data-name": "Path 55841",
    d: "M3.212.014h9.245a3.218,3.218,0,0,1,3.214,3.214V10.21l0,2.833a.459.459,0,0,1-.649,0l-1.976-1.815-9.837.135A3.218,3.218,0,0,1,0,8.147V3.228A3.218,3.218,0,0,1,3.212.014ZM.916,8.147a2.3,2.3,0,0,0,2.3,2.3l10.027-.135a.459.459,0,0,1,.325.135L14.8,11.677l-.045-1.468a19.973,19.973,0,0,0,0-2.017V3.228a2.3,2.3,0,0,0-2.3-2.3H3.212a2.3,2.3,0,0,0-2.3,2.3Zm0,0",
    transform: "translate(0.002 -0.014)",
    fill: "#758522",
    stroke: "#758522",
    strokeWidth: 0.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCom);
export default __webpack_public_path__ + "static/media/com.45616339cb9616e706314dd64662bf7a.svg";
export { ForwardRef as ReactComponent };